import { useAtom } from 'jotai';
import { domain } from 'modules/data';
import { useCallback } from 'react';
import { contentSplitViewState } from 'shared/states';

export const useShowNextAttachment = () => {
    const [contentSplitView, setContentSplitView] = useAtom(contentSplitViewState);

    return useCallback(
        (activeAttachmentId: string, attachments: domain.RequestAttachment[]) => {
            if ('attachmentId' in contentSplitView && attachments.length > 1) {
                const attachmentIndex = attachments.findIndex((attachment) => attachment.id === activeAttachmentId);

                const newAttachmentIndex = attachmentIndex === attachments.length - 1 ? 0 : attachmentIndex + 1;

                setContentSplitView({
                    ...contentSplitView,
                    attachmentId: attachments[newAttachmentIndex].id,
                });
            }
        },
        [contentSplitView, setContentSplitView]
    );
};
